export default {"src":"/_next/static/media/zero_scrap_value.e4bde08b.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};